import React, { useContext } from 'react';
import moment from 'moment';
import { SmartContext } from '../../../../library/Core/SmartContext';

const NoteFormModal = ({ data }: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const { description, setDescription, handleAddNote, errors } = data;

    const showFlag = state?.modalFlags?.addCounsellorNotes;
    

    return (
        <div
            id="add-CounsellorNotes"
            className={`modal fade ${showFlag ? 'show' : ''}`} // removed vh-100 and show class
            tabIndex={-1}
            role="dialog"
            style={{ display: showFlag ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered max-600 mx-auto">
                <div className="modal-content">
                    <div className="modal-header p-4 height-70 border-0 bg-gray-f2">
                        <h5 className="modal-title" id="staticBackdropLabel">
                           Counsellor Note
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-small"
                            onClick={() => {
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'addCounsellorNotes' } });
                            }}
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-4">
                        <form className="needs-validation" noValidate>
                            <div className="row g-4">
                                <div className="col-md-12">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <label htmlFor="skills" className="form-label m-0 mb-1 font-16 font-500">
                                            Description
                                        </label>
                                    </div>
                                    <textarea
                                    className={`form-control ${errors?.description ? 'is-invalid' : ''}`}
                                    id="description"
                                    name="description"
                                    style={{ height: '100px' }}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Ex: The achievement is a rare one, and worth highlighting." />

                                    {errors?.description && (
                                    <div className="invalid-feedback d-block">{errors.description}</div>
                                    )}
                                </div>
                            </div>
                            <div className="row justify-content-center align-items-center p-4">
                                <div className="col-auto">
                                    {/* <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">Cancel</button> */}
                                </div>
                                <div className="col-auto">
                                    <button
                                        type="button"
                                        className="btn btn-green max-135"
                                        onClick={() => handleAddNote()}
                                        >
                                         <span>{data?.editingNote ? 'Update' : 'Add'}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoteFormModal;
